<main class="privacy-policy-page min-h-svh px-5 pt-4 pb-6" id="legal-privacy">
  <article class="privacy-policy-container mx-auto">
    <header class="privacy-policy-header pt-8 pb-7">
      <h1 class="text-3xl font-semibold">
        {{ 'PRIVACY_POLICY.TITLE' | translate }}
      </h1>
    </header>

    <div class="privacy-policy-content text-wr grid gap-3">
      <section class="privacy-policy-section px-6 py-6 border rounded-lg bg-white">
        <h2 class="text-xl font-semibold mb-3">User Provided Information</h2>
        <p>
          The Application obtains the information you provide when your account is created by your manager. Then, you will receive your credentials by email. You must use them to connect to the Application.
        </p>
        <p>
          We may use the information you provided us (name and email address) to contact your from time to time to provide you with important information and required notices regarding the application.
        </p>
      </section>

      <section class="privacy-policy-section px-6 py-6 border rounded-lg bg-white">
        <h2 class="text-xl font-semibold mb-3">
          What information does the Application obtain and how is it used?
        </h2>
        <p>
          The application gets the sell information such as the product identification and the warranty details.
        </p>
      </section>

      <section class="privacy-policy-section px-6 py-6 border rounded-lg bg-white">
        <h2 class="text-xl font-semibold mb-3">Automatically Collected Information</h2>
        <p>
          In addition, the Application may collect certain information automatically, including the type of mobile device you use, your mobile operating system or application crash reports.
        </p>
      </section>

      <section class="privacy-policy-section px-6 py-6 border rounded-lg bg-white">
        <h2 class="text-xl font-semibold mb-3">
          Does the Application collect precise real time location information of the device?
        </h2>
        <p>
          This Application does not collect precise information about the location of your mobile device.
        </p>
      </section>

      <section class="privacy-policy-section px-6 py-6 border rounded-lg bg-white">
        <h2 class="text-xl font-semibold mb-3">
          Does the Application has special needs to function properly?
        </h2>
        <p>
          The application need a internet connection, it’s mandatory to transfer real time sells information to eWarranty central module.
        </p>
        <p>
          The application also requests an access to your camera for scanning features. If your refuse, you have the opportunity to enter manually the information about the sell.
        </p>
      </section>

      <section class="privacy-policy-section px-6 py-6 border rounded-lg bg-white">
        <h2 class="text-xl font-semibold mb-3">What are my opt-out rights?</h2>
        <p>
          You can stop all collection of information by the Application easily by not using or uninstalling the Application. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network.
        </p>
      </section>

      <section class="privacy-policy-section px-6 py-6 border rounded-lg bg-white">
        <h2 class="text-xl font-semibold mb-3">
          Data Retention Policy, Managing Your Information
        </h2>
        <p>
          We will retain User Provided data for as long as you use the Application and for a reasonable time thereafter. We will retain Automatically Collected information and aggregated data. If you’d like us to delete User Provided Data (first name, last name, email address) that you have provided via the Application, please contact your manager and he will transfer your request to us under a reasonable time. Please note that some of the User Provided Data are required in order for the Application to function properly.
        </p>
      </section>

      <section class="privacy-policy-section px-6 py-6 border rounded-lg bg-white">
        <h2 class="text-xl font-semibold mb-3">Security</h2>
        <p>
          We are concerned about safeguarding the confidentiality of your information. We provide physical, electronic, and procedural safeguards to protect information we process and maintain. For example, we limit access to this information to authorized employees and contractors who need to know that information in order to operate, develop or improve our Application. Please be aware that, although we endeavor provide reasonable security for information we process and maintain, no security system can prevent all potential security breaches.
        </p>
      </section>

      <section class="privacy-policy-section px-6 py-6 border rounded-lg bg-white">
        <h2 class="text-xl font-semibold mb-3">Changes</h2>
        <p>
          This Privacy Policy may be updated from time to time. We will notify you of any changes to our Privacy Policy by posting the new Privacy Policy here. You are advised to consult this Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.
        </p>
      </section>

      <section class="privacy-policy-section px-6 py-6 border rounded-lg bg-white">
        <h2 class="text-xl font-semibold mb-3">Your consent</h2>
        <p>
          By using the Application, you are consenting to our processing of your information as set forth in this Privacy Policy now and as amended by us. Your information will be transferred, processed and stored by Dentsu International Switzerland AG.
        </p>
      </section>

      <section class="privacy-policy-section privacy-policy-contact px-6 py-6 border rounded-lg bg-white">
        <h2 class="text-xl font-semibold mb-3">Contact us</h2>
        <p>
          If you have any questions regarding privacy while using the Application, or have questions about our practices, please contact your manager or <a class="text-link break-words" [href]="'mailto:' + companyContactEmail">{{ companyContactEmail }}</a>.
        </p>
      </section>
    </div>
  </article>

  <footer class="privacy-policy-footer w-full mt-8 px-5 py-5 border-t text-sm">
    <div class="privacy-policy-footer-container flex items-center justify-between gap-4 w-full mx-auto">
      <a class="privacy-policy-footer-link font-semibold" href="/">Go to login</a>
    </div>
  </footer>
</main>
